// Third Party Library
import { Pagination} from "antd";
import { useEffect } from "react";

// Constants

// Components

// Handlers

// services

// styles

const TablePagination = (props) => {
  const {
    tabKey,
    data = [],
    filteredDataCount,
    onPaginatedDataChange,
    pageSize,
    setPageSize,
    current,
    setCurrent,
  } = props;

  useEffect(() => {
    updatePaginatedData();
  }, [current, pageSize, data]);

  const updatePaginatedData = () => {
    const newData = data?.slice((current - 1) * pageSize, current * pageSize);

    // If you want to notify external components about paginatedData changes
    if (onPaginatedDataChange) {
      onPaginatedDataChange(newData);
    }
  };

  const handlePaginationChange = (page, pageSize) => {
    setCurrent(page);
    setPageSize(pageSize);
  };

  return (
      <Pagination
        current={current}
        pageSize={pageSize}
        total={data.length}
        onChange={handlePaginationChange}
        showTotal={(total) => (
          <div style={{ fontSize: 13 }}>{filteredDataCount && filteredDataCount[tabKey]} results </div>
        )}
        style={{
          display: "flex",
          justifyContent: "end",
        }}
        size="small"
        showSizeChanger
      />
  );
};

export default TablePagination;
